define('common/models/appstate',['require','exports','module','backbone','../../modules/lp_integration/models/integration_correodirect','env','./csv_file','ThemesHelper'],function (require, exports, module) {
  'use strict';
  //AppState is a singleton model used across the application routers
  var Backbone = require('backbone'),
    CorreoDirectModel = require('../../modules/lp_integration/models/integration_correodirect'),
    config = require('env'),
    CsvFile = require('./csv_file'),
    ThemesHelper = require('ThemesHelper');

  var AppState = Backbone.Model.extend({
    defaults: {
      /** used to allow/disallow leaving the editor page **/
      navigationAllowed: true,
      navigationConfirmMessage: '¿Está seguro?',
      /** used to enable/disable keyboard event capturing **/
      editor_props_open: false,
      allPlatforms: false,
    },

    initialize: function (attrs, options) {
      this._appStorage = {};
      this._companyInfoStatus = false;
      this._companyInfo = new Backbone.Model({
        correo_direct_is_available: false,
      });
      this._csvFile = new CsvFile();
    },

    /** keep a reference to the editor variant model **/
    setVariant: function (ref) {
      this.set('editor_variant', ref);
    },

    getVariant: function () {
      return this.get('editor_variant');
    },

    /** keep editor view state - is the user editing properties? **/
    isPropsPopUpOpen: function () {
      return !!this.get('editor_props_open');
    },

    setPropsPopUpOpen: function (isOpen) {
      this.set('editor_props_open', isOpen);
    },

    /** create page from template **/
    //appStorage acts as an app-wide key-value container
    //so that any module can share data with others
    //Example: AppState.saveItem("newPage", newPageModel)
    //         var savedModel = AppState.getItem("newPage")
    saveItem: function (name, item) {
      this._appStorage[name] = item;
    },

    getItem: function (name) {
      return this._appStorage[name];
    },

    /** navigation with dirty views */
    toggleNavigation: function (isAllowed, message) {
      if (isAllowed === undefined) {
        isAllowed = true;
      }
      this.set('navigationAllowed', isAllowed);
      if (message) {
        this.set('navigationConfirmMessage', message);
      }
      if (!isAllowed) {
        //store current url
        this.set('navigationCurrentUrl', window.location.pathname);
      }
    },

    setNavigationConfirmMessage: function (message) {
      this.set('navigationConfirmMessage', message);
    },

    onBeforeUnload: function (e) {
      if (this.get('changing')) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        e.preventDefault();
        this.set('changing', false);
        return void 0;
      }

      if (config.disablePageRefreshWarning) {
        return void 0;
      }

      if (this._shouldPrevent()) {
        return this.get('navigationConfirmMessage');
      } else {
        //release reference to the variant
        this.unset('editor_variant');
      }
    },

    _shouldPrevent: function () {
      return this.get('navigationAllowed') === false;
    },

    initCompanyInfo: function (info) {
      this.setCompanyInfo(info);
    },

    setCompanyInfo: function (info) {
      this._companyInfo.set(info);
      this._companyInfoStatus = true;
    },

    isCorreoDirectAvailable: function () {
      return this._companyInfo.get('correo_direct_is_available');
    },

    isCorreoDirectActive: function (pageId) {
      var correodirectData = new CorreoDirectModel({ id: 'correodirect' }, { pageId: pageId });
      return correodirectData.fetch();
    },

    getCountryId: function () {
      return this._companyInfo.get('countryId');
    },
    getMaxVisits: function () {
      return this._companyInfo.get('maxVisits');
    },

    isAppSumo: function () {
      return this._companyInfo.get('isAppSumo');
    },

    getAllPlatforms: function () {
      var allPlatforms = this.get('allPlatforms');
      this.set('allPlatforms', false);
      return allPlatforms;
    },

    setCsvToDownload: function (info) {
      this._csvFile.set(info);
    },

    unsetCsvToDownload: function () {
      this._csvFile.reset();
    },
  });

  return new AppState();
});

